export default "/images/send.svg?fab9d9661d8d41abd207906755d8209e";